import { REQUEST_LANDLORD_STATUS, REQUEST_LINK_TOKEN } from '../constants/ActionConstants';
import ConfigModel from '../models/Config';

const initState = ConfigModel();

const configReducer = (state = initState, action) => {
  switch (action.type) {
    case REQUEST_LANDLORD_STATUS.SUCCESS: {
      const config = action.payload.config;
      if (!config) return state;
      return {
        ...state,
        stripePublicKey: config.stripePublicKey,
        plaidEnv: config.plaidEnv,
      };
    }
    case REQUEST_LINK_TOKEN.SUCCESS:
      return {
        ...state,
        plaidLinkToken: action.payload.data.plaidLinkToken,
        plaidLinkTokenExpiration: action.payload.data.plaidLinkTokenExpiration,
      };
    default:
      return state;
  }
};

export default configReducer;
